import { useState, useCallback } from 'react';
import { Form, message } from 'antd';
import { useTranslation } from 'react-i18next';

import userApi from '@api/userApi';

function useRecoveryPassword() {

  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onOk = useCallback(async () => {

    let values;
    try {

      values = await form.validateFields();

    } catch (error) {

      return null;

    }

    const { email } = values;
    setLoading(true);
    userApi
      .resetPassword(email)
      .then((response) => {

        setLoading(false);
        message.success(t('forms.recovery_password.feedbacks.success_recovery'));

        setTimeout(() => {

          setVisible(false);

        }, 500);

      })
      .catch((resError) => {

        setLoading(false);
        const { statusText } = resError;
        message.error(statusText);

      });

    return null;

    // eslint-disable-next-line
  }, []);

  return {
    visible, setVisible, loading, form, onOk,
  };

}

export default useRecoveryPassword;
